import React from 'react';

interface SenderIconProps {
    width?: number;
    height?: number;
    className?: string;
}

const SenderIcon: React.FC<SenderIconProps> = ({width = 17, height = 14, className}) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width={width} 
            height={height} 
            viewBox="0 0 17 14" 
            fill="none"
            className={className}
        >
            <g clipPath="url(#clip0_13311_13255)">
                <path d="M9.57794 12.9869C9.425 12.9864 9.27844 12.9254 9.17047 12.817C9.06251 12.7087 9.00177 12.5619 9.00177 12.4089V9.69496C8.76077 9.68796 8.51783 9.68495 8.28083 9.68495C7.07148 9.65347 5.86399 9.7973 4.69586 10.1119C3.48912 10.477 2.38433 11.1191 1.46979 11.9869C1.36791 12.0805 1.2353 12.1333 1.09699 12.135H1.06989C0.921936 12.1342 0.780197 12.0755 0.675112 11.9713C0.570027 11.8672 0.509969 11.726 0.507876 11.578C0.43944 10.4338 0.595349 9.28734 0.96686 8.20301C1.30869 7.2588 1.89339 6.42137 2.66193 5.77503C4.07093 4.57503 6.20399 3.94102 9.00299 3.88502V1.07801C9.00488 0.925263 9.06494 0.77893 9.17096 0.668954C9.22468 0.615002 9.28856 0.572358 9.35895 0.543344C9.42934 0.51433 9.50474 0.49958 9.58087 0.500009C9.65547 0.499903 9.72944 0.514798 9.79816 0.543832C9.86688 0.572866 9.92885 0.615391 9.98078 0.668954L15.6138 6.33802C15.7189 6.44829 15.7774 6.59467 15.7774 6.74696C15.7774 6.89924 15.7189 7.04575 15.6138 7.15601L9.98786 12.8099H9.98078C9.93059 12.8671 9.86851 12.9125 9.79889 12.9431C9.72927 12.9737 9.65396 12.9886 9.57794 12.9869ZM8.33185 8.52296C8.73185 8.52296 9.15578 8.53304 9.60578 8.55103C9.7537 8.55574 9.89387 8.61827 9.99616 8.72523C10.0984 8.83219 10.1548 8.97495 10.1529 9.12293V11.005L14.39 6.74598L10.1529 2.48695V4.46803C10.1536 4.54358 10.1391 4.61846 10.1104 4.68836C10.0817 4.75826 10.0392 4.82172 9.98566 4.87501C9.93209 4.9283 9.86845 4.97034 9.7984 4.99867C9.72835 5.027 9.6535 5.041 9.57794 5.03993H9.40485C6.64585 5.03993 4.68077 5.56804 3.39777 6.65504C2.88053 7.118 2.46232 7.68076 2.16828 8.30958C1.87423 8.9384 1.71049 9.62021 1.68683 10.314C2.50089 9.72882 3.4065 9.28311 4.36676 8.995C5.65856 8.64804 6.9947 8.48902 8.33185 8.52296Z" fill="#5A5B5E" stroke="#5A5B5E" strokeWidth="0.5"/>
            </g>
            <defs>
                <clipPath id="clip0_13311_13255">
                    <rect width="16.338" height="13.487" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default SenderIcon;
